// extracted by mini-css-extract-plugin
export default {"RegistryHeaderImage":"RegistryHeaderImage-styles__RegistryHeaderImage__Tj1gK"};